<template>
  <div class="fill-height bg-studio">
    <v-fade-transition mode="out-in">
      <router-view :baseRoute="baseRoute" :search="search"></router-view>
    </v-fade-transition>
  </div>
</template>

<script>
export default {
  name: "ListasPrecioLayout",
  props: ["baseRoute", "search"]
};
</script>